import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import React, { useEffect, useRef } from 'react'
import './Calendar.css'

const Calendar = ({ events, onShipDateChange, onSelectLine, onMonthChange, month }) => {
    const pendingDrops = useRef(new Set());
    const calendarRef = useRef(null);
    useEffect(() => {
        const calendar = calendarRef.current?.getApi();
        if (calendar && month && calendar.view.currentStart.toISOString().slice(0, 7) !== month) {
            calendar.gotoDate(`${month}-01`);
        }
    }, [month]);

    const renderEventContent = (eventInfo) => <div className="shipping-chip-title" title={eventInfo.event.extendedProps.preview || eventInfo.event.title}>{eventInfo.event.title}</div>

    const handleEventDrop = async (eventDropInfo) => {
        const { event, revert } = eventDropInfo;
        if (pendingDrops.current.has(event.id)) {
            revert();
            return;
        }
        pendingDrops.current.add(event.id);
        try {
            const saved = await onShipDateChange(event.id, event.extendedProps.opportunityId, event.startStr.slice(0, 10));
            if (!saved) revert();
        } catch (error) {
            revert();
        } finally {
            pendingDrops.current.delete(event.id);
        }
    }

    return (
        <div className="row hive-calendar" style={{ minHeight: "100vh" }}>
            <div className="col-lg-12">
                <FullCalendar
                    ref={calendarRef}
                    initialDate={month ? `${month}-01` : undefined}
                    height="85%"
                    aspectRatio={2}
                    plugins={[dayGridPlugin, interactionPlugin]}
                    initialView="dayGridMonth"
                    weekends={true}
                    events={events}
                    eventContent={renderEventContent}
                    editable={true}
                    eventDurationEditable={false}
                    eventDrop={handleEventDrop}
                    eventClick={({ event }) => onSelectLine?.(event.id)}
                    datesSet={({ view }) => onMonthChange?.(view.currentStart.toISOString().slice(0, 7))}
                    timeZone='UTC'
                />
            </div>
        </div>
    )
}

export default Calendar
